/**
 * Marka ve genel SaaS kök alanı (örn. firma.otomanager.com).
 * Geçersizlemek için: REACT_APP_MAIN_SAAS_PUBLIC_HOST
 */
export const MAIN_SAAS_PUBLIC_HOST = (
  process.env.REACT_APP_MAIN_SAAS_PUBLIC_HOST || "otomanager.com"
)
  .trim()
  .toLowerCase();

/** Canlı demo vitrin — https://demo.otomanager.com */
export const DEMO_SHOP_HOST = (
  process.env.REACT_APP_DEMO_SHOP_HOST || `demo.${MAIN_SAAS_PUBLIC_HOST}`
)
  .trim()
  .toLowerCase();

export const PRODUCT_NAME = "Oto Manager";

export const MAIN_SITE_URL = `https://${MAIN_SAAS_PUBLIC_HOST}`;

/** Kiracı subdomain tam host (örn. altin.otomanager.com) */
export function tenantSubdomainHost(sub) {
  const s = String(sub || "")
    .trim()
    .toLowerCase();
  if (!s) return "";
  return `${s}.${MAIN_SAAS_PUBLIC_HOST}`;
}
